module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point02_01_miyakoblue-12c8ec76fe92d33760c361b49e88da22.jpg";